exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* Palette of colours used to distinguish repeated elements */\n.clearfix:after {\n  content: \".\";\n  visibility: hidden;\n  clear: both;\n  display: block;\n  overflow: hidden;\n  height: 1px;\n}\n.circle {\n  border-radius: 999px;\n}\n.bg-cover {\n  background-position: center center !important;\n  background-size: cover !important;\n  -webkit-background-size: cover !important;\n  -moz-background-size: cover !important;\n  -o-background-size: cover !important;\n}\n.right {\n  float: right !important;\n}\n.left {\n  float: left;\n}\n.hidden-input {\n  visibility: hidden;\n  position: absolute;\n}\n/* Table with highlightable rows for displaying lists of\n   programs, waves, groups or users. */\n.dashboard-navigation {\n  padding-left: 0;\n}\n.dashboard-navigation ::ng-deep .tabs-dashboard {\n  width: 100% !important;\n}\n.dashboard-navigation ::ng-deep .tabs-dashboard > li {\n  width: calc(85%);\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/dashboard/dashboard-navigation/dashboard-navigation.component.less
// module id = ../../../../../src/app/dashboard/dashboard-navigation/dashboard-navigation.component.less
// module chunks = 2